import { useRef } from "react";
import { Button, Input, Space } from "antd";
import type { TextAreaRef } from "antd/es/input/TextArea";
import { parseFormattedTaskText } from "./task-text-format";

export function TaskFormattedText({ text }: { text: string }) {
  return <>{parseFormattedTaskText(text).map((paragraph, i) => <p className="task-phone-copy" key={i}>{paragraph.map((segment, j) => <span key={j} className={`task-text-${segment.type}`}>{segment.text}</span>)}</p>)}</>;
}
export function TaskTextEditor({ value = "", onChange, placeholder, id }: { value?: string; onChange?: (value: string) => void; placeholder?: string; id?: string }) {
  const ref = useRef<TextAreaRef>(null);
  const format = (open: string, close: string) => {
    const input = ref.current?.resizableTextArea?.textArea;
    const start = input?.selectionStart ?? value.length;
    const end = input?.selectionEnd ?? start;
    const selected = value.slice(start, end) || "重点内容";
    onChange?.(value.slice(0, start) + open + selected + close + value.slice(end));
    requestAnimationFrame(() => { input?.focus(); input?.setSelectionRange(start + open.length, start + open.length + selected.length); });
  };
  return <div className="task-text-editor">
    <Space wrap size={6} className="task-text-toolbar">
      <Button size="small" onClick={() => format("**", "**")}>加粗</Button>
      <Button size="small" onClick={() => format("[红色]", "[/红色]")}>红色重点</Button>
      <Button size="small" onClick={() => format("[大字]", "[/大字]")}>大字标题</Button>
      <span>选中文字后设置样式，效果见手机预览</span>
    </Space>
    <Input.TextArea id={id} ref={ref} value={value} onChange={e => onChange?.(e.target.value)} rows={4} maxLength={5000} showCount placeholder={placeholder} />
  </div>;
}
